import React from 'react';
import Post from '../../Post';
import SectionHeadingStyle2 from '../../SectionHeading/SectionHeadingStyle2';
import GalleryVideosStyle3 from '../../GalleryDetails/GalleryVideosStyle3';

export default function VideosSection({ data, sectionTitleUp, sectionTitle }) {
  return (
    <div className="container">
      <SectionHeadingStyle2
        sectionTitleUp={sectionTitleUp}
        sectionTitle={sectionTitle}
        redirectUrl={'/videos'}
      />
      <div className="row justify-content-md-center">
        {data.map((item, index) => (
          <div className="col-lg-4" key={index}>
            <GalleryVideosStyle3
              imgLink={item.imgLink}
              isVideo={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
